import { PATCH } from "../APiHelper/API"

export const setGameCancelled = (data, onSuccess, onError) => {
    // const data = {
    //     fixture_id: fixture_id,
    //     league_id: league_id,
    //     cancelled: cancelled,
    // }
    PATCH(`/api/v1/games/cancelled`, data, onSuccess, onError)
}